































import { Vue,Component } from 'vue-property-decorator'
import { State,Action,namespace } from 'vuex-class'
import PagedTable from '../../components/common/pagedTable.vue'
const financial = namespace('financial')
@Component({
    components: {
        PagedTable,
    }
})
export default class SmsRechargeList extends Vue{
    @financial.State('smsrRechangePager') smsrRechangePager:any
    @financial.State('smsRechargeList') smsRechargeList:any
    @financial.State('loading') loading:any
    site:string = '' //网点id
    time:any = []
    partner:string = '' //快递员id
    multipleSelection:any = [] //勾选的项
    get search() {
        let start = ''
        let end = ''
        if(this.time){
            start = this.time[0]
            end = this.time[1]
        }
        return {
            site: this.site,
            start: start,
            end: end,
            pageSize: 20,
            page: 1
        }
    }
    get tablecolumn(){
        return [
            {
                prop: 'ctime',
                type: 'text',
                label: '日期',
            },
            {
                prop: 'content',
                type: 'text',
                label: '内容',
            },
            {
                prop: 'fee',
                type: 'text',
                label: '充值金额',
            },
            {
                prop: 'out_trade_no',
                type: 'text',
                label: '订单号'
            },
            {
                prop: 'present',
                type: 'text',
                label: '赠送金额',
            },
            {
                prop: 'total_fee',
                type: 'text',
                label: '共计',
            }
        ]
    }
    @financial.Action('getSmsRechargeList') getSmsRechargeList:any

    created(){
        this.getList()
    }
    getList(){
        this.getSmsRechargeList(this.search)
    }
    // 网点改变的时候
    changeSite(val:string){
        this.site = val
        this.getList()
    }
    // 翻页
    pagechange(e:any){
        this.search.page = e[0].val;
        this.getList();
    }
    pageSizechang(e){
        this.search.pageSize = e[0].val;
        this.getList();
    }
    // 勾选前面的选项时
    multiplechange(e:any){
        this.multipleSelection = e
    }
    // 导出数据
    exportexcel(){
        const data = this.multipleSelection
        if(data.length < 1) return this.$message.error('选择需要导出的数据')
        require.ensure([], () => {
            const { export_json_to_excel } = require('../../assets/vendor/Export2Excel');
            const tHeader = ['日期','门店','内容','充值金额','订单号','赠送金额','共计'];
            const p = [tHeader]
            data.map((item:any)=>{
                p.push([item.ctime,item.site.name,item.content,item.fee,item.out_trade_no,item.present,item.total_fee])
            })
            const pk = [{
                sheetName:"短信充值记录",
                data:p
            }];
            const extitle = `短信充值记录`
            export_json_to_excel(pk,extitle);
        })
    }
}
